import Ractive from 'ractive';
import { Button } from './elements/Button/Button';
import { Checkbox } from './elements/Checkbox/Checkbox';
import { Combobox } from './elements/Combobox/Combobox';
import { ContextMenuHost } from './elements/ContextMenu/ContextMenuHost';
import { FormLabel } from './elements/FormLabel/FormLabel';
import { IconButton } from './elements/IconButton/IconButton';
import { Link } from './elements/Link/Link';
import { TimeNumeric } from './elements/Numerics/TimeNumeric/TimeNumeric';
import { SLTPNumeric } from './elements/Numerics/TradingNumerics/SLTPNumeric/SLTPNumeric';
import { TradingNumeric } from './elements/Numerics/TradingNumerics/TradingNumeric/TradingNumeric';
import { SideToggle } from './elements/OptionSelectors/SideToggle/SideToggle';
import { SecretField } from './elements/SecretField/SecretField';
import { Stack } from '@front/sharedcomponents/Stack/Stack';
import { TooltipClick } from './elements/Tooltip/TooltipClick';
import { TooltipDecorator } from './elements/Tooltip/TooltipDecorator';
import { TooltipError } from './elements/Tooltip/TooltipError';
import { TooltipHover } from './elements/Tooltip/TooltipHover';
import { Typography } from './elements/Typography/Typography';
import { PositionsPanel } from './panels/PositionsPanel/PositionsPanel';
import { StatementPanel } from './panels/StatementPanel/StatementPanel';
import { createReactAdapter, createReactDecoratorAdapter } from './RactiveAdaptor';
import { AlertMessageBox } from './screens/AlertMessageBox/AlertMessageBox';
import { MessageBox } from './screens/MessageBox/MessageBox';
import { QRCodeScreen } from './screens/QRCodeScreen/QRCodeScreen';
import { UpdateNotificationScreen } from './screens/UpdateNotificationScreen/UpdateNotificationScreen';
import { WebhooksCodeSnippet } from './screens/WebhooksScreen/elements/WebhooksCodeSnippet';
Ractive.components.reactStack = createReactDecoratorAdapter(Stack);
Ractive.components.reactTypography = createReactDecoratorAdapter(Typography);
Ractive.components.reactTooltipDecorator = createReactDecoratorAdapter(TooltipDecorator);
Ractive.components.reactFormLabel = createReactDecoratorAdapter(FormLabel);
Ractive.components.reactTooltipHover = createReactAdapter(TooltipHover);
Ractive.components.reactTooltipClick = createReactAdapter(TooltipClick);
Ractive.components.reactTooltipError = createReactAdapter(TooltipError);
Ractive.components.reactButton = createReactAdapter(Button);
Ractive.components.reactIconButton = createReactAdapter(IconButton);
Ractive.components.reactSecretField = createReactAdapter(SecretField);
Ractive.components.reactCheckbox = createReactAdapter(Checkbox);
Ractive.components.reactCombobox = createReactAdapter(Combobox);
Ractive.components.reactSideToggle = createReactAdapter(SideToggle);
Ractive.components.reactContextMenuInstance = createReactAdapter(ContextMenuHost);
Ractive.components.reactTimeNumeric = createReactAdapter(TimeNumeric);
Ractive.components.reactTradingNumeric = createReactAdapter(TradingNumeric);
Ractive.components.reactSLTPNumeric = createReactAdapter(SLTPNumeric);
Ractive.components.reactLink = createReactAdapter(Link);
//#region Screens
Ractive.components.reactUpdateNotificationScreen = createReactAdapter(UpdateNotificationScreen);
Ractive.components.reactQRCodeScreen = createReactAdapter(QRCodeScreen);
Ractive.components.reactMessageBox = createReactAdapter(MessageBox);
Ractive.components.reactAlertMessageBox = createReactAdapter(AlertMessageBox);
//#region Webhooks screen
Ractive.components.reactWebhooksCodeSnippet = createReactAdapter(WebhooksCodeSnippet);
//#endregion
Ractive.components.reactPositionsPanel = createReactAdapter(PositionsPanel);
Ractive.components.reactStatementPanel = createReactAdapter(StatementPanel);
//#endregion
